import { useState } from "react";
import {
  Accordion,
  AccordionItem,
  AccordionTrigger,
  AccordionContent,
  AccordionHeader,
  AccordionTitleText,
  AccordionIcon,
} from "ui/gluestack/accordion";
import { Text, View, TouchableOpacity } from "react-native";
import { ChevronDownIcon, ChevronUpIcon } from "ui/gluestack/icon";
import { AssessmentModel } from "app/services/api/types/forms/models/AssessmentModel";
import { AssessmentSectionModel } from "app/services/api/types/forms/models/AssessmentSectionModel";

type Props = {
  form: AssessmentModel;
  sections: AssessmentSectionModel[];
  onMenuItemClick: (sectionId: number) => void;
};

export default function AssessmentSectionLinks({
  form,
  sections,
  onMenuItemClick,
}: Props) {
  const [activeSectionId, setActiveSectionId] = useState<number | null>(null);

  const handleClick = (id: number) => {
    setActiveSectionId(id);
    onMenuItemClick(id);
  };

  return (
    <Accordion
      variant="filled"
      type="single"
      isCollapsible={true}
      isDisabled={false}
      defaultValue={["a"]}
      className="bg-secondary-0 rounded-lg px-1 py-3"
    >
      <AccordionItem value="a" className="bg-secondary-0">
        <AccordionHeader>
          <AccordionTrigger>
            {({ isExpanded }) => (
              <>
                <AccordionTitleText className="font-medium text-base px-2">
                  {form.name}
                </AccordionTitleText>
                {isExpanded ? (
                  <AccordionIcon as={ChevronUpIcon} />
                ) : (
                  <AccordionIcon as={ChevronDownIcon} />
                )}
              </>
            )}
          </AccordionTrigger>
        </AccordionHeader>

        <AccordionContent>
          <View>
            {sections?.map((section) => {
              const isActive = section.id === activeSectionId;

              return (
                <TouchableOpacity
                  key={section.id}
                  onPress={() => handleClick(section.id)}
                >
                  {isActive ? (
                    <View className="bg-primary-0 p-2 rounded-lg">
                      <Text className="font-medium ">{section.name}</Text>
                    </View>
                  ) : (
                    <Text className="font-normal p-2">{section.name}</Text>
                  )}
                </TouchableOpacity>
              );
            })}
          </View>
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  );
}
